import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { CBMError, Changelog } from 'app/models';
import { ChangelogService } from 'app/services';

@Component({
  selector: 'changelog',
  templateUrl: './changelog.component.html',
  styleUrls: ['./changelog.component.scss']
})
export class ChangelogComponent implements OnChanges {
  @Input() siterecordId: number;
  @Input() ascending = true;

  public changelogsByVersion: Changelog[][] = [];
  public errorMessages: CBMError[] = [];

  /* NOTE: ascending input is now a one-time operation.
    If you want to change 'ascending' on the fly:
    *** store the GET results as well, not just 'changelogsByVersion'
    *** implement ngOnChanges to re-sort it all
    */

  constructor(private readonly changelogService: ChangelogService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('siterecordId')) {
      this.getChangelogForSiterecord(this.siterecordId);
    }
  }

  private getChangelogForSiterecord(siterecordId: number): void {
    this.changelogService.getChangelogForSiterecord(siterecordId).subscribe(
      changelogs => {
        this.changelogsByVersion = this.aggregateChangelogsByRecordVersionNr(changelogs);
      },
      (errors: CBMError[]) => {
        this.errorMessages = errors;
      }
    );
  }

  private sortChangelogsByDate(changelogs: Changelog[], asc: boolean): Changelog[] {
    return changelogs.sort((ca, cb) => {
      if (asc) {
        if (ca.creationDateTime < cb.creationDateTime) {
          return -1;
        } else if (ca.creationDateTime === cb.creationDateTime) {
          return 0;
        } else {
          return 1;
        }
      } else {
        if (ca.creationDateTime > cb.creationDateTime) {
          return -1;
        } else if (ca.creationDateTime === cb.creationDateTime) {
          return 0;
        } else {
          return 1;
        }
      }
    });
  }

  private aggregateChangelogsByRecordVersionNr(changelogs: Changelog[]): Changelog[][] {
    if (changelogs == null || changelogs.length === 0) {
      return [[]];
    }

    // sort the changelogs first, so all the dates and times are in order
    this.sortChangelogsByDate(changelogs, this.ascending);

    // now aggregate them, but the 'version groups' also need to be in order
    const maxVersionNr: number = changelogs.map(c => c.recordVersionNr).reduce((a, b) => Math.max(a, b));

    const versions: Changelog[][] = [];
    for (const c of changelogs) {
      let versionIndex: number;

      if (this.ascending) {
        versionIndex = c.recordVersionNr - 1;
      } else {
        versionIndex = maxVersionNr - c.recordVersionNr;
      }
      if (versions[versionIndex] == null) {
        versions[versionIndex] = [];
      }
      versions[versionIndex].push(c);
    }

    return versions;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/changelog/changelog.component.ts